<template>
  <swiper
    :modules="modules"
    :slides-per-view="1"
    :speed="800"
    :space-between="0"
    navigation
    :pagination="paginationObject"
    class="module-image-slider"
    :class="classes"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    ref="swiperRef"
  >
    <swiper-slide v-for="(slide, index) in sliders" :key="index">
      <slot :data="slide" />
    </swiper-slide>
  </swiper>
</template>
<script lang="ts">
import { ref, defineComponent, watch, onMounted } from 'vue'

// import Swiper core and required modules
import { Navigation, Pagination } from 'swiper'

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    sliders: {
      type: Array,
      default: () => [],
    },
    slideActiveId: {
      type: [String, Number],
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    pagination: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      swiper: null,
      modules: [Navigation, Pagination],
    }
  },

  methods: {
    /**
     * @description Handling getting the first active id slide when loading the component
     */
    onSwiper(swiper: any) {
      this.swiper = swiper
      const slideActive: any = this.sliders[swiper.activeIndex]
      this.$emit('activeStepId', slideActive.id)
    },

    /**
     * @description Handle slide change to specific index by id
     */
    onSlideTo(id: string) {
      const vm: any = this
      const index = this.sliders.findIndex((item: any) => item.id == id)
      vm.swiper.slideTo(index)
    },

    /**
     * @description Handle slide change and emit current active slide
     */
    onSlideChange() {
      const vm = this
      const slideActive: any = vm.sliders[vm.swiper.activeIndex]
      this.$emit('activeStepId', slideActive.id)
    },
  },
  computed: {
    paginationObject() {
      if (this.pagination)
        return {
          clickable: true,
        }
      return false
    },
  },

  watch: {
    slideActiveId: {
      handler(val) {
        this.onSlideTo(val)
      },
    },
  },
})
</script>
<style scoped>
.module-image-slider :deep() .swiper-pagination {
  bottom: 0;
}

.module-image-slider :deep() .swiper-pagination-bullet {
  @apply bg-dark-grey;
  background: #cccccc;
  width: 10px;
  height: 10px;
  margin: 0 5px !important;
}
.module-image-slider :deep() .swiper-pagination-bullet-active {
  @apply bg-black;
}

.module-image-slider :deep() .swiper-button-prev:after,
.module-image-slider :deep() .swiper-rtl .swiper-button-next:after {
  @apply text-black text-xl;
}

.module-image-slider :deep() .swiper-button-next:after,
.module-image-slider :deep() .swiper-rtl .swiper-button-prev:after {
  @apply text-black text-xl;
}

@media only screen and (max-width: 480px) {
  .module-image-slider :deep() .swiper-button-next {
    top: 33%;
  }

  .module-image-slider :deep() .swiper-button-prev {
    top: 33%;
  }
}
</style>
